import { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { ChartContainer } from '../../../../../common/chart/chartContainer'
import Bar from '../../../../../common/chart/chartContainer/Bar'
import Line from '../../../../../common/chart/chartContainer/Line'
import { LegendItem } from '../../../../../common/chart/legend/LegendItem'
import { Element } from '../../../../../common/html/element'
import { Icon } from '../../../../../common/html/icon'
import { SCREEN } from '../../../../../common/selectCurrencyUnit/constant'
import { useFormatCurrency } from '../../../../../common/selectCurrencyUnit/useFormatCurrency'
import { Tooltip } from '../../../../../common/tooltip'
import { getUnique } from '../../../../../helpers/common'
import { convertData, valToPercent } from '../../../../../helpers/value'
import { selectUserType } from '../../../../../layout/store/slice'
import { USER_TYPE } from '../../../../../utils/authorization'
import {
  getNoDataComponent,
  getStyleHeightContainer,
  getValueAndTitleCheckbox,
  handleIconDownload,
} from '../../helper'
import classes from '../../index.module.scss'
import { changeChecked, selectChecked } from '../../store/slice'
import { EXCEPT_KEYS, PERCENTAGE_KEYS, TREND_DATA } from './constant'
import { selectDataViewByTrend, selectIndicatorById } from './store/slice'

const Trend = ({ id, isDynamicReport, check, isDownloadComponent }) => {
  const chartId = useRef(getUnique())

  const dispatch = useDispatch()
  const locale = useSelector((state) => state.i18n.locale)
  const userType = useSelector(selectUserType)
  const {
    formatedUnit,
    getExchangeRate,
    multiplier,
    formatValueWithUnit,
    decimalLength,
  } = useFormatCurrency(SCREEN.FINANCIAL_ANALYSIS)
  const dataByTrend = useSelector(selectDataViewByTrend)
  const indicatorById = useSelector(selectIndicatorById)
  const checkedStore = useSelector(selectChecked(id))

  const checked = checkedStore || check

  const setChecked = (checked) => dispatch(changeChecked({ id, checked }))

  const dataConvert = convertData(
    dataByTrend,
    getExchangeRate,
    indicatorById,
    multiplier,
    EXCEPT_KEYS,
    PERCENTAGE_KEYS,
  )

  const checkboxs = TREND_DATA.map((item) => ({
    ...item,
    ...getValueAndTitleCheckbox(indicatorById, item.value),
  }))

  const bars = checkboxs.filter(
    (item) => item.isBarChart && checked.includes(item.value),
  )

  const lines = checkboxs.filter(
    (item) => item.isLineChart && checked.includes(item.value),
  )

  const isNoData = !dataConvert.length

  useEffect(() => {
    handleIconDownload(id, isNoData)
  }, [isNoData])

  if (isNoData) {
    return getNoDataComponent(isDynamicReport)
  }

  const isNotHasBar = !bars.length

  return (
    <div
      style={{
        height: getStyleHeightContainer(
          isDynamicReport || isDownloadComponent,
          isNoData,
          332,
        ),
      }}
      className={`flexColumn ${classes.profitabilityTrenContainer}`}
    >
      <Element className={classes.pdb6} style={{ color: '#9C9C9C' }}>
        {!isNotHasBar ? formatedUnit : <>&nbsp;</>}
      </Element>
      <div className="dFlex h100">
        <ChartContainer
          chartId={chartId.current}
          data={dataConvert}
          margin={{
            top: 10,
            bottom: 0,
            left: isNotHasBar ? 16 : isDownloadComponent ? 26 : 0,
            right: isDownloadComponent ? 26 : 0,
          }}
          width="70%"
          height="100%"
          xAxis={[{ dataKey: 'year' }]}
          yAxis={[
            {
              yAxisId: 'left',
              dataKeys: bars.map((item) => item.value),
              isBarChart: true,
              hide: isNotHasBar,
              decimalLength,
              isDynamicReport: isDynamicReport || isDownloadComponent,
            },
            {
              yAxisId: 'right',
              orientation: 'right',
              dataKeys: lines.map((item) => item.value),
              isLineChart: true,
              unit: '%',
              isDynamicReport: isDynamicReport || isDownloadComponent,
            },
          ]}
          tooltip={{
            schema: {
              content: [
                ...bars.map((bar) => ({
                  dataKey: bar.value,
                  label: bar.title,
                  formatValue: (value) => formatValueWithUnit({ value }),
                })),
                ...lines.map((line) => ({
                  dataKey: line.value,
                  label: line.title,
                  formatValue: (value) => valToPercent(value, locale, true),
                })),
              ],
            },
          }}
        >
          {bars.map((bar) => (
            <Bar
              key={bar.value}
              yAxisId="left"
              dataKey={bar.value}
              fill={bar.color}
              maxBarSize={25}
            />
          ))}
          {lines.map((line) => (
            <Line
              key={line.value}
              yAxisId="right"
              dataKey={line.value}
              stroke={line.color}
            />
          ))}
        </ChartContainer>
        <div className="h100 w30 px1 py1 flexColumn justifyContentCenter">
          {checkboxs.map((item, index) => (
            <div
              className="dFlex alignItemsCenter"
              key={item.value}
              style={{ marginTop: index ? 6 : 0 }}
            >
              <LegendItem
                title={
                  <>
                    {item.title}
                    {!isDynamicReport &&
                      !isDownloadComponent &&
                      item.tooltipContent && (
                        <Tooltip
                          elementName="span"
                          tooltipContent={item.tooltipContent}
                        >
                          <Icon
                            className="icon-info-circle ml1"
                            style={{ color: '#9C9C9C', marginTop: 2 }}
                          />
                        </Tooltip>
                      )}
                  </>
                }
                isI18n={false}
                value={item.value}
                color={item.color}
                isCheckbox={userType?.userTypeId === USER_TYPE.PREMIUM}
                dataKey={item.value}
                chartId={chartId.current}
                listCheckBox={checked}
                setListCheckBox={setChecked}
                isDynamicReport={isDynamicReport || isDownloadComponent}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default Trend
